<template>
  <div class="manage">
    <div class="manage-table">
      <el-form :inline="true" size="mini" class="demo-form-inline">
        <el-form-item>
          <el-button type="success" @click="onAddClick" :disabled="!hasCommitPermission">新增授权</el-button>
        </el-form-item>
      </el-form>

      <el-table stripe class="right-desc" border :data="tableData" size="mini">
        <el-table-column prop="id" label="ID" width="60"></el-table-column>
        <el-table-column prop="name" label="授权名称"></el-table-column>
        <el-table-column prop="areaNames" label="包含区域"></el-table-column>
        <el-table-column prop="comments" label="备注"></el-table-column>
        <el-table-column prop="createTime" label="创建时间" width="160">
          <template v-slot="scope">
            {{ scope.row.createTime | timeFilter }}
          </template>
        </el-table-column>
        <el-table-column label="操作" width="180px">
          <template v-slot="scope">
            <el-button type="primary" size="mini" @click="onEditClick(scope.row)">编辑</el-button>
            <el-button type="danger" size="mini" @click="onDeleteClick(scope.row)" :disabled="!hasCommitPermission">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <el-drawer :with-header="false" :visible.sync="drawerShow" size="550px">
      <el-header class="el-header">
        <div>{{ drawerTitle }}</div>
      </el-header>
      <el-main class="el-main">
        <div class="main-content">
          <el-form class="drawer-form" size="mini">
            <el-form-item label="授权名称：" required>
              <el-input v-model="form.name" placeholder="请输入授权名称"></el-input>
            </el-form-item>
            <el-form-item label="通行区域：" required>
              <el-input v-model="form.areaNameDisplay" placeholder="请选择通行区域" readonly @focus="areaDialogShow = true"></el-input>
            </el-form-item>
            <el-form-item label="备注：">
              <el-input v-model="form.comments" placeholder="请输入备注" type="textarea" :rows="3"></el-input>
            </el-form-item>
          </el-form>
        </div>
      </el-main>
      <el-footer>
        <div class="footer-content">
          <el-button size="mini" @click="drawerShow = false">取消</el-button>
          <el-button size="mini" type="primary" @click="onSaveClick" :disabled="!hasCommitPermission">保存</el-button>
        </div>
      </el-footer>
    </el-drawer>

    <el-dialog title="选择通行区域" :visible.sync="areaDialogShow" width="400px">
      <el-tree :data="areaList" :props="defaultProps" ref="areaTree" show-checkbox node-key="id" :default-checked-keys="form.areaIds" default-expand-all></el-tree>
      <div slot="footer" class="dialog-footer">
        <el-button size="mini" @click="areaDialogShow = false">取消</el-button>
        <el-button size="mini" type="primary" @click="onAreaDialogConfirm">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  addAreaAuth,
  updateAreaAuth,
  deleteAreaAuth,
  getAllAreaAuth,
  getAllArea
} from "@/api/device-manager-api";

export default {
  name: "AreaAuthMgrPage",
  data() {
    return {
      tableData: [],
      areaList: [],
      defaultProps: {
        children: "areas",
        label: "name",
      },
      selectTree: {id: -1, name: "选择区域"},
      drawerShow: false,
      drawerTitle: "新增区域授权",
      areaDialogShow: false,
      form: {
        id: null,
        name: "",
        areaIds: [],
        areaNameDisplay: "",
        comments: "",
      },
    };
  },
  mounted() {
    this.loadAreaAuthList();
    this.loadAreaList();
  },
  methods: {
    loadAreaAuthList() {
      getAllAreaAuth().then(({data}) => {
        if (data.code === 200) {
          this.tableData = data.data || [];
        } else {
          this.showServerErrMsg(data.code);
        }
      }).catch(() => {
        this.showNetErrMsg();
      });
    },
    loadAreaList() {
      getAllArea().then(({data}) => {
        if (data.code === 200) {
          this.areaList = data.data || [];
        }
      }).catch(() => {});
    },
    onAddClick() {
      this.drawerTitle = "新增区域授权";
      this.form = {
        id: null,
        name: "",
        areaIds: [],
        areaNameDisplay: "",
        comments: "",
      };
      this.drawerShow = true;
    },
    onEditClick(row) {
      this.drawerTitle = "编辑区域授权";
      this.form = {
        id: row.id,
        name: row.name,
        areaIds: row.areaIds || [],
        areaNameDisplay: row.areaNames || "",
        comments: row.comments,
      };
      this.drawerShow = true;
    },
    onDeleteClick(row) {
      this.$confirm("确认删除该授权？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        deleteAreaAuth(row.id).then(({data}) => {
          if (data.code === 200) {
            this.$message.success("删除成功");
            this.loadAreaAuthList();
          } else {
            this.showServerErrMsg(data.code);
          }
        }).catch(() => {
          this.showNetErrMsg();
        });
      }).catch(() => {});
    },
    onAreaDialogConfirm() {
      const checkedNodes = this.$refs.areaTree.getCheckedNodes();
      this.form.areaIds = checkedNodes.map((node) => node.id);
      this.form.areaNameDisplay = checkedNodes.map((node) => node.name).join(", ");
      this.areaDialogShow = false;
    },
    onSaveClick() {
      if (!this.form.name || this.form.name.trim() === "") {
        this.$message.warning("请输入授权名称");
        return;
      }
      if (!this.form.areaIds || this.form.areaIds.length === 0) {
        this.$message.warning("请选择至少一个通行区域");
        return;
      }
      const postData = {
        id: this.form.id,
        name: this.form.name,
        areaIds: this.form.areaIds,
        comments: this.form.comments,
      };
      const api = this.form.id ? updateAreaAuth : addAreaAuth;
      api(postData).then(({data}) => {
        if (data.code === 200) {
          this.$message.success(this.form.id ? "修改成功" : "新增成功");
          this.drawerShow = false;
          this.loadAreaAuthList();
        } else {
          this.showServerErrMsg(data.code);
        }
      }).catch(() => {
        this.showNetErrMsg();
      });
    },
  },
  computed: {
    hasCommitPermission() {
      switch (this.$store.state.roleType) {
        case "ADMIN":
        case "MANAGE":
          return true;
        case "VIEW":
        case "GUARD":
        case "STAFF":
          return false;
        case "COMMON":
          return this.$store.state.myPermissions.includes("AREA_AUTH_MANAGE_MODIFY");
        default:
          return false;
      }
    },
  },
  filters: {
    timeFilter(value) {
      if (!value || value.length < 19) {
        return value;
      }
      return value.substring(0, 10) + " " + value.substring(11, 19);
    },
  },
};
</script>

<style scoped lang="less">
.manage-table {
  .right-desc {
    /deep/ .el-table__body-wrapper {
      min-height: calc(100vh - 260px);
    }
    /deep/ .el-table__body-wrapper::-webkit-scrollbar {
      width: 0px;
    }
  }
}
.manage-table > .demo-form-inline {
  margin-bottom: 20px;
}
.option-style {
  overflow: auto;
  height: 100%;
}
.el-header {
  text-align: center;
  line-height: 60px;
}
.el-main {
  height: calc(100% - 120px);
  padding: 0;
}
.el-footer {
  text-align: center;
  line-height: 60px;
}
.el-main > .main-content > .drawer-form > .el-form-item {
  display: flex;
  justify-content: flex-start;
  /deep/ .el-form-item__label {
    width: 100px;
  }
  /deep/ .el-input,
  /deep/ .el-select {
    width: calc(20vw);
  }
}
</style>
